import Vue from 'vue';
import utils from '../../Shared/utils.jsx';
import careHelpfulFunctions from '../careHelpfulFunctions.jsx';
import methods from '../../Shared/methods';
import BaseComponent from './BaseComponentMixin.jsx';
import "./css/RealTimeGrid.css";
import { AgGridVue } from 'ag-grid-vue';
//import 'ag-grid-enterprise'; // Required for SSRM
import _ from 'lodash'; // For debounce

const CellButtons = {
    data: () => ({
        type: 'CellButtons',
        rowData: null,
        c_context: null,
        condition_expn: null,
    }),
    created() {
        this.rowData = this.params.data;
        this.c_context = this.params.customdata.context;
        this.condition_expn = this.params.customdata.ColumnDef.condition_expn;

        const rowModelName = this.params.customdata.ColumnDef.RowModelName || 'row';

        for (let btn of this.params.customdata.ColumnDef.CommandButtons) {
            if (btn.Condition && !btn.$$Condition) {
                btn.$$Condition = utils.compileExpression(this, btn.Condition, rowModelName);
            }

            if (btn.Icon && !btn.$$Icon)
                btn.$$Icon = utils.compile(this, btn.Icon, false, rowModelName);

            if (btn.Color && !btn.$$Color)
                btn.$$Color = utils.compile(this, btn.Color, false, rowModelName);

            if (btn.Tooltip && !btn.$$Tooltip)
                btn.$$Tooltip = utils.compile(this, btn.Tooltip, false, rowModelName);

            if (btn.$$Condition) {
                btn.$$Condition_watch = this.$watch(
                    function () {
                        if (btn.$$Icon)
                            utils.evaluate(btn.$$Icon, this.c_context, false, null, false, this.rowData);
                        if (btn.$$Color)
                            utils.evaluate(btn.$$Color, this.c_context, false, null, false, this.rowData);
                        if (btn.$$Tooltip)
                            utils.evaluate(btn.$$Tooltip, this.c_context, false, null, false, this.rowData);

                        return utils.evaluate(btn.$$Condition, this.c_context, false, null, false, this.rowData);
                    },
                    function (val) {
                        //console.log(`Redrawing RealTimeGridAg cell due to a change in the condition: ${btn.$$Condition.code}; value: ${val}`);
                        this.params.api.redrawRows();
                    }
                );
            }
        }
    },
    destroyed() {
        for (let btn of this.params.customdata.ColumnDef.CommandButtons) {
            if (btn.$$Condition_watch)
                btn.$$Condition_watch(); // dispose of the watch
        }
    },
    methods: {
        ...methods,
        rowMenuClick(e, data, btn, m) {
            e.stopPropagation();
            utils.executeAndCompileAllActions(m.Actions, { RowIndex: -1, Data: this.rowData }, this.c_context);
        },
        menuOpenClose(state, data, btn, m) {
            if (btn.OnMenuOpen)
                utils.executeAndCompileAllActions(btn.OnMenuOpen, { RowIndex: -1, Data: this.rowData, State: state }, this.c_context);
        },
        rowCommandClick(e, data, btn) {
            e.stopPropagation();
            utils.executeAndCompileAllActions(btn.Actions, { RowIndex: -1, Data: this.rowData }, this.c_context);
        },
        refresh(e) {
            for (let item in e.data) {
                Vue.set(this.rowData, item, e.data[item]);
            }
        },
    },
    render(h) {
        const data = this.rowData;
        const elements = [];
        if (this.condition_expn) {
            try {
                if (!utils.evaluate(this.condition_expn, this.c_context, false, null, false, data))
                    return null;
            }
            catch (ex) {
                console.warn(`Could not evaluate: ${this.condition_expn.code} with data:${JSON.stringify(data)} - ${ex.message}`);
                return null;
            }
        }
        //for (let btn of this.params.customdata.ColumnDef.CommandButtons) {
        for (let i = 0; i < this.params.customdata.ColumnDef.CommandButtons.length; i++) {
            const btn = this.params.customdata.ColumnDef.CommandButtons[i];

            if (!utils.document_cache.hasAccess('real-time grid command button', btn.AccessPermission))
                continue;

            if (btn.$$Condition && !utils.evaluate(btn.$$Condition, this.c_context, false, null, false, data))
                continue;

            let color = btn.$$Color ? utils.evaluate(btn.$$Color, this.c_context, false, null, false, data) : undefined;
            let icon = btn.$$Icon ? utils.evaluate(btn.$$Icon, this.c_context, false, null, false, data) : undefined;

            const rowModelName = this.params.customdata.ColumnDef.RowModelName || 'row';

            let b;
            if (btn.Menu && btn.Menu.length > 0) {
                const scopedSlots = {
                    activator: ({ on, attrs }) =>
                        <v-btn elevation={0}
                            v-show={!btn.$$Condition || utils.evaluate(btn.$$Condition, this.c_context, false, null, false, data)}
                            icon small
                            {...{ on }}
                            {...{ attrs }}
                        >
                            <v-icon
                                style={{ color: color }}
                                small>
                                {icon}
                            </v-icon>
                        </v-btn>
                };

                const items = [];
                for (let i = 0; i < btn.Menu.length; i++) {
                    const m = btn.Menu[i];
                    if (m.Separator)
                        items.push(<v-divider></v-divider>);
                    else {
                        if (!utils.document_cache.hasAccess('real-time grid command button menu', m.AccessPermission))
                            continue;

                        if (m.EnabledExpression && !m.$$enabledexpn)
                            m.$$enabledexpn = utils.compileExpression(this, m.EnabledExpression, rowModelName);

                        if (m.Icon && !m.$$iconexpn)
                            m.$$iconexpn = utils.compile(this, m.Icon, rowModelName);

                        if (m.Icon && m.IconColor && !m.$$iconcolorexpn)
                            m.$$iconcolorexpn = utils.compile(this, m.IconColor, rowModelName);

                        let menuicon;
                        if (m.$$iconexpn) {
                            let iconcolor = m.$$iconcolorexpn ? utils.evaluate(m.$$iconcolorexpn, this.c_context, false, null, false, data) : undefined;
                            menuicon =
                                <v-list-item-icon>
                                    <v-icon style={{ color: iconcolor }} small>{utils.evaluate(m.$$iconexpn, this.c_context, false, null, false, data)}</v-icon>
                                </v-list-item-icon>;
                        }

                        items.push(
                            <v-list-item
                                key={i}
                                disabled={(m.$$enabledexpn && !utils.evaluate(m.$$enabledexpn, this.c_context, false, null, false, data)) ? true : false}
                                on-click={(e) => this.rowMenuClick(e, data, btn, m)}>
                                {menuicon}
                                <v-list-item-content>
                                    <v-list-item-title>{m.Title}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        );
                    }
                }

                b = (
                    <v-menu
                        offset-x
                        close-on-click={true}
                        close-on-content-click={true}
                        scopedSlots={scopedSlots}
                        on-input={(state) => this.menuOpenClose(state, data, btn)}
                    >
                        <v-list dense>
                            <v-list-item-group>
                                {items}
                            </v-list-item-group>
                        </v-list>
                    </v-menu>
                );
            }
            else if (btn.Actions && btn.Actions.length > 0) {
                b = (
                    <v-btn elevation={0}
                        icon small
                        on-click={(e) => this.rowCommandClick(e, data, btn)}>
                        <v-icon
                            style={{ color: color }}
                            small>
                            {icon}
                        </v-icon>
                    </v-btn>
                );
            }
            else {
                b = (
                    <v-btn elevation={0}
                        style={{ cursor: 'default' }}
                        depressed
                        icon small>
                        <v-icon
                            style={{ color: color }}
                            small>
                            {icon}
                        </v-icon>
                    </v-btn>
                );
            }

            if (btn.$$Tooltip) {
                const tooltip = utils.evaluate(btn.$$Tooltip, this.c_context, false, null, false, data);
                if (tooltip)
                    b = utils.generateTooltip(h, b, tooltip, 'right');
            }

            elements.push(b);
        }
        return (<div class="c-RealTimeGrid-button">{elements}</div>);
    }
};

Vue.component('real-time-grid', {
    mixins: [BaseComponent],
    components: {
        CellButtons,
        AgGridVue
    },
    data: function () {
        return {
            id: null,
            gridName: null,
            totalRows: 0,
            rowdata: [],
            loading: false,
            columnDefs: [],
            gridOptions: null,
            gridApi: null,
            columnApi: null,
            dense: false,
            searchText: "",
            viewname: 'UserList~!!~null',
            sortCol: 'StartTime',
            descending: false,
            start: 0,
            paginationPageSize: 10, // Replaces length for SSRM
            defaultRowsPerPage: 5,
            selected_items: [],
            selectableKey: "id",
            column_visibility: null,
            menu_is_open: false,
            lastRequestParams: null,
            isSubscribed: false,
            rtretry$: null,
            retryCount$: 0,
            currentPage: 1,
            resizeObserver: null,
            datasource: null,
            autoSizeStrategy: {
                type: 'fitGridWidth',
                defaultMinWidth: 100,
            }
        };
    },
    async created() {
        this.gridName = `RealTimeGrid_${this.controlData.Name || 'Unnamed'}`;
        const settings = this.System.LocalStorage(this.gridName + '.ColumnSettings');
        if (settings) {
            this.column_visibility = JSON.parse(settings);
        } else if (this.controlData.ColumnDefs && this.controlData.ColumnDefs.length) {
            this.column_visibility = careHelpfulFunctions.arrayToObject(this.controlData.ColumnDefs, a => a.Field, b => b.Visible);
        } else {
            this.column_visibility = {};
        }

        const options = this.System.LocalStorage(this.gridName + '.Options');
        if (options) {
            const parsed = JSON.parse(options);
            this.gridOptions = {
                ...parsed,
                rowModelType: 'serverSide',
                serverSideDatasource: this.createServerSideDatasource(),
                pagination: true,
                paginationPageSize: this.paginationPageSize,
                animateRows: true,
                suppressRowClickSelection: true,
                paginationAutoPageSize: true,
                isRowSelectable: (params) => {
                    if (!this.controlData.SelectOptions || !this.controlData.SelectOptions.Enable) {
                        return false;
                    }

                    if (this.selectableexpn) {
                        return utils.evaluate(this.selectableexpn, this, false, null, false, params.data);
                    }

                    return true;
                },
                getRowId: (params) => {
                    return params.data._id.toString();
                },
                enableCellTextSelection: true,
            };
        } else {
            this.gridOptions = {
                rowModelType: 'serverSide',
                serverSideDatasource: this.createServerSideDatasource(),
                pagination: true,
                paginationPageSize: this.paginationPageSize,
                animateRows: true,
                suppressRowClickSelection: true,
                paginationAutoPageSize: true,
                isRowSelectable: (params) => {
                    if (!this.controlData.SelectOptions || !this.controlData.SelectOptions.Enable) {
                        return false;
                    }

                    if (this.selectableexpn) {
                        return utils.evaluate(this.selectableexpn, this, false, null, false, params.data);
                    }

                    return true;
                },
                getRowId: (params) => {
                    return params.data._id.toString();
                },
                enableCellTextSelection: true,
            };
        }

        if (this.controlData.RTEventSource)
            this.rteventsource_func = utils.compileExpression(this, this.controlData.RTEventSource);

        if (this.controlData.ListSource)
            this.listNameExpn = utils.compileObject(this, this.controlData.ListSource);

        if (this.controlData.Filters)
            this.filtersexpn = utils.compileObject(this, this.controlData.Filters);

        if (this.controlData.SelectOptions && this.controlData.SelectOptions.Enable && this.controlData.SelectOptions.SelectableExpression)
            this.selectableexpn = utils.compileExpression(this, this.controlData.SelectOptions.SelectableExpression, 'row');

        this.dense = !!this.controlData.Dense;

        if (this.controlData.SelectOptions && this.controlData.SelectOptions.Enable && this.controlData.SelectOptions.SelectableKey)
            this.selectableKey = this.controlData.SelectOptions.SelectableKey;

        if (this.controlData.DefaultRowsPerPage)
            this.defaultRowsPerPage = this.controlData.DefaultRowsPerPage;

        this.setupColumnDefs();
    },
    mounted() {
        //this.updateVisibleRows();
        //this.setupResizeObserver();
        //window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        //if (this.resizeObserver) {
        //    this.resizeObserver.disconnect();
        //}
        //window.removeEventListener('resize', this.handleResize);
    },
    destroyed() {
        if (this.watch_date_value$) this.watch_date_value$();
        if (this.datawatch$) this.datawatch$();
        if (this.filters_watch$) this.filters_watch$();
        if (this.listname_watch$) this.listname_watch$();
        if (this.rtactive_watch$) this.rtactive_watch$();
        if (this.rtretry$) clearTimeout(this.rtretry$);
        if (this.viewname && this.id && this.rtEvents) this.rtEvents.RemoveNamedListForRealTime(this.viewname, this.id);
    },
    computed: {
        filters: function () {
            return this.filtersexpn ? utils.evaluateObject(this.filtersexpn, this) : null;
        },
        listName: function () {
            return this.listNameExpn ? utils.evaluateObject(this.listNameExpn, this) : null;
        },
        serverProperties: function () {
            const columns = this.generateHeaders().filter(a => a.field && a.field != '_menu_').map(a => a.field);
            let serverProperties = columns;
            if (this.controlData.AdditionalProperties) {
                const additionalProperties = this.controlData.AdditionalProperties.filter(a => a).map(b => b.trim());
                serverProperties = _.uniq([...columns, ...additionalProperties]);
            }
            return serverProperties;
        },
        menuContent: function () {
            const h = this.$createElement;
            const menus = [];
            if (this.controlData.ColumnDefs && this.controlData.ColumnDefs.length) {
                for (let c of this.controlData.ColumnDefs.filter(cd => cd.Field)) {
                    menus.push(
                        <v-list-item key={`${c.Field}`} on-click={() => { /*this.menu_is_open = false;*/ this.toggleColumnVisibility(c.Field); }}>
                            <v-list-item-icon>
                                <v-icon>{this.column_visibility[c.Field] ? 'mdi-check' : ''}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    <translation-container context={this} value={c.DisplayName || c.Field} />
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    );
                }
            }
            const scopedSlots = {
                activator: ({ on, attrs }) =>
                    <v-btn elevation={0} plain {...{ on }} {...{ attrs }}>
                        <v-icon>mdi-menu</v-icon>
                    </v-btn>
            };
            return (
                <v-menu
                    offset-y
                    bottom left
                    close-on-click={true}
                    close-on-content-click={false}
                    scopedSlots={scopedSlots}
                    value={this.menu_is_open}
                    on-input={(state) => this.menu_is_open = state}
                >
                    <v-list dense style="max-height: 600px" class="overflow-y-auto">
                        <v-list-item-group>{menus}</v-list-item-group>
                    </v-list>
                </v-menu>
            );
        },
        gridHeaderControls: function () {
            const h = this.$createElement;
            const items = [];
            if (this.controlData.GridHeaderControls && Array.isArray(this.controlData.GridHeaderControls) && this.controlData.GridHeaderControls.length > 0) {
                for (let i = 0; i < this.controlData.GridHeaderControls.length; i++) {
                    const c = this.controlData.GridHeaderControls[i];

                    let DynamicControl = utils.getDynamicComponent(h, c);

                    if (!DynamicControl)
                        DynamicControl = 'default-unknown';

                    items.push(
                        <DynamicControl
                            on={{ 'finished-render': (reference) => this.finishRenderHandler(reference) }}
                            type={c.ControlType}
                            name={c.ControlData.Name ? c.ControlData.Name : ''}
                            root={this.root}
                            parentType="HorizontalStack"
                            controlData={c.ControlData}
                            controlURL={c.ControlURL}
                            controlName={c.Name}
                            accessPermission={c.AccessPermission}
                            scopeitems={this.scopeitems}
                            controlscope={this.controlscope}
                            cacheControl={c.CacheControl}
                            controlEvents={c.Events}>
                        </DynamicControl>);
                }
            }
            return items;
        },
        rtEvents: function () {
            return this.rteventsource_func ? utils.evaluate(this.rteventsource_func, this) : null;
        },
        rtViews: function () {
            // View cache of this grid's RT event source. Falls back to the native slot so
            // grids with a missing/unresolved RTEventSource behave exactly as before.
            const src = this.rtEvents || this.GlobalVars.RTData;
            return src ? src.Views : undefined;
        },
        showSelect: function () {
            return this.controlData.SelectOptions.Enable;
        },
        singleSelect: function () {
            return !this.controlData.SelectOptions.MultiSelect;
        },
        SelectedRowsAsArray: {
            get: function () {
                return this.selected_items;
            },
            set: function (value) {
                this.selected_items = value;
            }
        },
        totalPages: function () {
            return Math.ceil(this.totalRows / this.paginationPageSize) || 1;
        },
        canGoPrevious: function () {
            return this.currentPage > 1;
        },
        canGoNext: function () {
            return this.currentPage < this.totalPages;
        },
    },
    methods: {
        preRenderComplete() {
            this.finishRenderHandler(this);

            this.filters_watch$ = this.$watch(
                () => this.filters,
                (newVal, oldVal) => {
                    if (!_.isEqual(newVal, oldVal)) {
                        this.currentPage = 1;
                        this.gridApi.refreshServerSide({ purge: true });
                    }
                },
                { deep: true }
            );

            this.listname_watch$ = this.$watch(
                () => this.listName,
                (newVal, oldVal) => {
                    if (newVal !== oldVal) {
                        this.currentPage = 1;
                        this.gridApi.refreshServerSide({ purge: true });
                    }
                },
                { deep: true }
            );

            // The grid subscribes once, when ag-grid is ready. A grid mounted before its
            // event source is streaming - a cross-center source added while the dashboard
            // is open - fails that one attempt and would stay empty until a page reload.
            // Re-run the subscription when the source comes up.
            this.rtactive_watch$ = this.$watch(
                () => {
                    const src = this.rtEvents;
                    return !!(src && src.IsActive);
                },
                (isActive) => {
                    if (!isActive || this.isSubscribed || !this.gridApi)
                        return;

                    this.lastRequestParams = null;
                    this.gridApi.refreshServerSide({ purge: true });
                }
            );
        },
        scheduleSubscribeRetry() {
            // The IsActive watcher above cannot help when the event source itself was
            // still undefined at mount, because no dependency on IsActive is registered
            // in that case. Back off up to ~30s for a bounded number of attempts.
            if (this.rtretry$ || this.retryCount$ >= 10)
                return;

            const delay = Math.min(1000 * Math.pow(2, this.retryCount$++), 30000);
            this.rtretry$ = setTimeout(() => {
                this.rtretry$ = null;

                const src = this.rtEvents;
                if (!this.isSubscribed && src && src.IsActive && this.gridApi) {
                    this.lastRequestParams = null;
                    this.gridApi.refreshServerSide({ purge: true });
                }
            }, delay);
        },
        addDataWatch() {
            if (!this.rtViews[this.viewname])
                Vue.set(this.rtViews, this.viewname, { Total: 0, Data: [] });

            // Dispose any existing watch
            if (this.datawatch$)
                this.datawatch$();

            this.datawatch$ = this.$watch(
                () => {
                    const views = this.rtViews;
                    return views && views[this.viewname];
                },
                (newv, oldv) => {
                    if (newv && newv.Refreshing) {
                        //utils.log(`RTData.Views['${this.viewname}'] changed but was refreshing from server side, so ignoring`);
                        return;
                    }

                    if (newv && this.gridApi) {
                        this.rowdata = newv.Data;
                        this.totalRows = newv.Total;

                        //utils.log(`RTData.Views['${this.viewname}'] changed; newv:${JSON.stringify(newv.Data)}`);
                        //utils.log(`RTData.Views['${this.viewname}'] changed; oldv:${JSON.stringify(oldv ? oldv.Data : [])}`);

                        if (this.totalRows == 0)
                            this.gridApi.showNoRowsOverlay();
                        else
                            this.gridApi.hideOverlay();

                        //this.rowdata.forEach((row, index) => row._id = index);

                        // Identify added, updated, and removed rows
                        const oldData = oldv && oldv.Data ? oldv.Data : [];
                        const newData = newv.Data || [];

                        // Added rows: Present in newData but not in oldData
                        const addedRows = newData.filter(
                            newRow => !oldData.some(oldRow => oldRow._id === newRow._id)
                        );

                        // Removed rows: Present in oldData but not in newData
                        const removedRows = oldData.filter(
                            oldRow => !newData.some(newRow => newRow._id === oldRow._id)
                        );

                        // Updated rows: Present in both, but data has changed
                        const updatedRows = newData.filter(newRow =>
                            oldData.some(oldRow =>
                                oldRow._id === newRow._id &&
                                !_.isEqual(oldRow, newRow)
                            )
                        );

                        // Apply transactions
                        if (removedRows.length > 0 || updatedRows.length > 0 || addedRows.length > 0) {
                            //utils.log(`RTData.Views['${this.viewname}'] changed; removedRows:${JSON.stringify(removedRows)}`);
                            //utils.log(`RTData.Views['${this.viewname}'] changed; updatedRows:${JSON.stringify(updatedRows)}`);
                            //utils.log(`RTData.Views['${this.viewname}'] changed; addedRows:${JSON.stringify(addedRows)}`);
                            this.gridApi.applyServerSideTransaction({
                                remove: removedRows,
                                update: updatedRows,
                                add: addedRows,
                            });
                        }
                        this.gridApi.setRowCount(this.totalRows);

                        //if (addedRows.length == 0 && updatedRows.length == 0 && removedRows.length == 0)
                        //    utils.log(`RTData.Views['${this.viewname}'] changed but detected no differences`);

                        // Refresh cells to update custom renderers (CellButtons)
                        if (addedRows.length > 0 || updatedRows.length > 0) {
                            this.gridApi.refreshCells({
                                columns: this.columnDefs
                                    .filter(cd => cd.cellRenderer === 'CellButtons')
                                    .map(cd => cd.field),
                                force: true,
                            });
                        }
                    }
                },
                { deep: true }
            );
        },
        updateSearchFilter(filter) {
            this.searchText = filter;
             if (!filter && this.filters?._any_) {
                delete this.filters._any_;
            }
            this.currentPage = 1;
            this.gridApi.refreshServerSide({ purge: true });
        },
        createServerSideDatasource() {
            return {
                getRows: async (params) => {
                    const request = params.request;
                    const currentRequestParams = {
                        listName: this.listName,
                        sortCol: request.sortModel.length > 0 ? request.sortModel[0].colId : this.sortCol,
                        descending: request.sortModel.length > 0 ? request.sortModel[0].sort === 'desc' : this.descending,
                        start: request.startRow,
                        length: request.endRow - request.startRow,
                        filter: { ...this.filters, ...(this.searchText ? { "_any_": this.searchText } : {}) },
                    };

                    if (this.isSubscribed && _.isEqual(currentRequestParams, this.lastRequestParams)) {
                        params.success({
                            rowData: this.rowdata,
                            rowCount: this.totalRows
                        });
                        return;
                    }

                    this.loading = true;
                    this.lastRequestParams = currentRequestParams;

                    let filter = this.filters || {};
                    if (this.searchText) {
                        filter["_any_"] = this.searchText;
                    }

                    try {
                        //utils.log(`GetNamedListForRealTime(listName:${this.listName},sortCol:${currentRequestParams.sortCol},descending:${currentRequestParams.descending},startRow:${request.startRow},length:${request.endRow - request.startRow},,filter:${JSON.stringify(filter)},id:${this.id})`);
                        const res = await this.rtEvents.GetNamedListForRealTime(
                            this.listName,
                            currentRequestParams.sortCol,
                            currentRequestParams.descending,
                            request.startRow,
                            request.endRow - request.startRow,
                            this.serverProperties,
                            filter,
                            this.id
                        );

                        if (res && res.Response) {
                            //utils.log(`RTView GetNamedListForRealTime(); id:${this.id}; res.ViewHash:${res.ViewHash}, id:${res.ID}; rawdata:${JSON.stringify(res.Response)}`);

                            const newViewname = res.ViewHash;
                            this.id = res.ID;
                            const rawdata = res.Response;

                            Vue.set(this.rtViews, newViewname, {
                                Refreshing: true,
                                Total: rawdata.Total,
                                Data: rawdata.Data,
                            });

                            this.rowdata = rawdata.Data;
                            this.totalRows = rawdata.Total;

                            this.rowdata.forEach((row, index) => row._id = index);

                            if (newViewname !== this.viewname && this.viewname) {
                                //this.rtEvents.RemoveNamedListForRealTime(this.viewname, this.id);
                            }
                            this.viewname = newViewname;
                            this.isSubscribed = true;
                            this.retryCount$ = 0;
                            this.addDataWatch();

                            if (rawdata.Total == 0)
                                params.api.showNoRowsOverlay();
                            else
                                params.api.hideOverlay();

                            params.success({
                                rowData: rawdata.Data,
                                rowCount: rawdata.Total
                            });
                        } else {
                            if (!this.rtViews[this.viewname])
                                Vue.set(this.rtViews, this.viewname, { Refreshing: true, Total: 0, Data: [] });

                            this.rowdata = this.rtViews[this.viewname].Data;
                            this.totalRows = this.rtViews[this.viewname].Total;

                            if (this.totalRows == 0)
                                params.api.showNoRowsOverlay();
                            else
                                params.api.hideOverlay();

                            params.success({
                                rowData: this.rowdata,
                                rowCount: this.totalRows
                            });
                        }
                    } catch (error) {
                        console.error('Error fetching data:', error);
                        // Render an empty grid instead of ag-grid's ERR row - a revoked
                        // or unreachable source should read as "no data", not an error
                        // artifact in the row area.
                        this.rowdata = [];
                        this.totalRows = 0;
                        params.api.showNoRowsOverlay();
                        // Reporting success marks the block loaded, so ag-grid will not
                        // ask again on its own. Clear the subscription state and the
                        // identical-request guard so a later retry can get through.
                        this.isSubscribed = false;
                        this.lastRequestParams = null;
                        this.scheduleSubscribeRetry();
                        params.success({ rowData: [], rowCount: 0 });
                    } finally {
                        this.loading = false;
                    }
                }
            };
        },
        onGridReady(params) {
            this.gridApi = params.api;
            this.columnApi = params.columnApi;
            this.gridApi.setServerSideDatasource(this.createServerSideDatasource());

            // Whenever the grid is resized, update the cache block size so we only request exactly the number
            // of rows we can see. If the user changes the page, it will have to request new data from the server.
            params.api.addEventListener('viewportChanged', () => {
                params.api.setCacheBlockSize(params.api.paginationGetPageSize());
            });

            this.watch_date_value$ = this.$watch(function () {
                return utils.helpers.chf.date_value.value;
            }, function (newvalue) {
                this.gridApi.refreshCells();
            });

            //this.gridApi.showNoRowsOverlay();
        },
        onSortChanged(params) {
            this.gridApi.refreshServerSide({ purge: true });
        },
        onFirstDataRendered(params) {
            this.columnApi.autoSizeAllColumns();
        },
        toggleColumnVisibility(fieldName) {
            Vue.set(this.column_visibility, fieldName, !this.column_visibility[fieldName]);
            this.System.LocalStorage(this.gridName + '.ColumnSettings', JSON.stringify(this.column_visibility));
            this.setupColumnDefs();
            this.gridApi.setColumnDefs(this.columnDefs);
        },
        selectedItemsChanged() {
            const selectedNodes = this.gridApi.getSelectedNodes();
            this.selected_items = selectedNodes.map(node => node.data);
        },
        actionButtons(params, cd) {
            const buttons = [];
            for (let cb of cd.CommandButtons) {
                buttons.push(
                    <CellButton
                        btn={cb}
                        cd={cd}
                        c_context={this}
                        rowData={params.data}
                    />
                );
            }
            return buttons;
        },
        setupColumnDefs() {
            this.columnDefs = [];
            if (this.controlData.SelectOptions && this.controlData.SelectOptions.Enable) {
                this.columnDefs.push({
                    checkboxSelection: true,
                    headerCheckboxSelection: !this.controlData.SelectOptions.MultiSelect,
                    width: 50,
                    pinned: 'left'
                });
            }

            if (this.controlData.ColumnDefs) {
                for (let cd of this.controlData.ColumnDefs) {
                    let field_extractor = () => '';
                    if (cd.Field) {
                        field_extractor = cd.field_extractor || new Function('f', `return f.${cd.Field};`);
                    }

                    // If visibility is not explicity defined, default to 
                    const isVisible = this.column_visibility.hasOwnProperty(cd.Field) ? this.column_visibility[cd.Field] : cd.Visible !== false;

                    const colDef = {
                        field: cd.Field,
                        headerName: this.Translate(cd.DisplayName || cd.Field || ''),
                        sortable: cd.ActionOnlyColumn ? false : cd.Sortable !== false,
                        hide: !isVisible,
                        resizable: true,
                        cellStyle: { display: 'flex', alignItems: 'center' },
                        //flex: 1,
                    };

                    if (cd.Field) {
                        if (cd.Condition && !cd.condition_expn)
                            cd.condition_expn = utils.compileExpression(this, cd.Condition, [cd.RowModelName || 'row', cd.ItemModelName || 'item']);
                        if (cd.Value && !cd.value_expn)
                            cd.value_expn = utils.compile(this, cd.Value, false, [cd.RowModelName || 'row', cd.ItemModelName || 'item']);
                        if (cd.CellFilter && !cd.cellfilter_expn) {
                            const filter = `{{ row.${cd.Field} | ${cd.CellFilter} }}`;
                            cd.cellfilter_expn = utils.compile(this, filter, false, ['row', cd.ItemModelName || 'item']);
                        }
                    }
                    if (cd.Align) {
                        colDef.cellStyle = { ...colDef.cellStyle, justifyContent: cd.Align };
                    }

                    if (cd.ActionOnlyColumn) {
                        colDef.cellRenderer = 'CellButtons';
                        colDef.cellRendererParams = {
                            customdata: {
                                root: this.root,
                                scopeitems: this.scopeitems,
                                controlscope: this.controlscope,
                                context: this,
                                ColumnDef: cd,
                            }
                        };
                    } else {
                        let valueGetter, valueFormatter;

                        if (cd.condition_expn && cd.value_expn) {
                            valueGetter = (params) => utils.evaluate(cd.condition_expn, this, false, null, false, [params.data, field_extractor(params.data)], true)
                                ? utils.evaluate(cd.value_expn, this, false, null, false, [params.data, field_extractor(params.data)], true)
                                : '';
                        } else if (cd.value_expn) {
                            valueGetter = (params) => utils.evaluate(cd.value_expn, this, false, null, false, [params.data, field_extractor(params.data)], true);
                        }

                        if (cd.cellfilter_expn && cd.condition_expn) {
                            valueFormatter = (params) => utils.evaluate(cd.condition_expn, this, false, null, false, [params.data, field_extractor(params.data)], true)
                                ? utils.evaluate(cd.cellfilter_expn, this, false, null, false, [params.data, field_extractor(params.data)], true)
                                : '';
                        } else if (cd.cellfilter_expn) {
                            valueFormatter = (params) => utils.evaluate(cd.cellfilter_expn, this, false, null, false, [params.data, field_extractor(params.data)], true);
                        } else if (cd.condition_expn && !valueGetter) {
                            valueFormatter = (params) => utils.evaluate(cd.condition_expn, this, false, null, false, [params.data, field_extractor(params.data)], true)
                                ? field_extractor(params.data)
                                : '';
                        }

                        if (!valueGetter && !valueFormatter) {
                            valueFormatter = (params) => {
                                try {
                                    const data = field_extractor(params.data);
                                    return typeof data === 'object' ? JSON.stringify(data) : data;
                                } catch (e) {
                                    utils.warn(`Grid cell failed to evaluate`, e);
                                    return '';
                                }
                            };
                        }

                        if (valueGetter) colDef.valueGetter = valueGetter;
                        if (valueFormatter) colDef.valueFormatter = valueFormatter;
                    }

                    this.columnDefs.push(colDef);
                }
            }
        },
        generateHeaders() {
            const headers = [];
            if (this.controlData.ColumnDefs) {
                for (let c of this.controlData.ColumnDefs) {
                    let cdef = {
                        field: c.Field,
                        text: this.Translate(c.DisplayName || c.Field),
                        align: c.Align || 'start',
                        sortable: !c.ActionOnlyColumn && c.Sortable !== false,
                        flex: 1,
                    };
                    headers.push(cdef);
                }
            }
            return headers;
        },
        ClearSelection() {
            this.gridApi.deselectAll();
            this.selected_items = [];
        },
        resizeColumns(e) {
            this.gridApi.autoSizeAllColumns();
        },
    },
    render(h) {
        if (!this.todisplay) return null;

        const style = {
            overflow: "auto",
            display: "flex",
            flexDirection: "column",
            padding: '8px',
            ...this.sizeStyle,
        };

        let resizebtn = (<v-btn elevation={0} plain on-click={(e) => this.resizeColumns(e)}>
            <v-icon>mdi-arrow-left-right-bold</v-icon>
        </v-btn>);

        resizebtn = utils.generateTooltip(h, resizebtn, this.Translate('Size columns to content'), 'bottom');

        return (
            <div
                v-show={this.isvisible}
                class={{ 'c-RealTimeGrid': true, [`c-name-${this.name || 'unnamed'}`]: true, 'ag-theme-alpine': true }}
                style={style}
            >
                <div style="display:flex; margin-bottom: 0px;" class="gridHeaderButtons">
                    {this.controlData.EnableFilter ?
                        <v-text-field
                            style="max-width: 300px;"
                            class="mb-1"
                            dense hide-details
                            clear-icon="mdi-close-circle"
                            clearable
                            placeholder={this.Translate("Quick Search")}
                            prepend-inner-icon="mdi-magnify"
                            value={this.searchText}
                            on-input={(value) => this.updateSearchFilter(value)}
                        ></v-text-field> :
                        <div></div>
                    }
                    <v-spacer />
                    {this.gridHeaderControls}
                    {resizebtn}
                    {this.menuContent}
                </div>
                <ag-grid-vue
                    style={{ width: '100%', height: '100%' }}
                    class="ag-theme-alpine"
                    gridOptions={this.gridOptions}
                    columnDefs={this.columnDefs}
                    rowSelection={this.showSelect ? (this.singleSelect ? 'single' : 'multiple') : null}
                    rowModelType="serverSide"
                    animateRows={true}
                    autoSizeStrategy={this.autoSizeStrategy}
                    suppressRowClickSelection={true}
                    onGridReady={this.onGridReady}
                    onSortChanged={this.onSortChanged}
                    onFirstDataRendered={this.onFirstDataRendered}
                    onSelectionChanged={this.selectedItemsChanged}
                    rowHeight={this.dense ? 28 : 44}
                    headerHeight={this.dense ? 32 : 48}
                />
            </div>
        );
    }
});